import { DialogActions } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import FormGroup from "@material-ui/core/FormGroup";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import MenuItem from "@material-ui/core/MenuItem";
import Modal from "@material-ui/core/Modal";
import Paper from "@material-ui/core/Paper";
import { withStyles } from "@material-ui/core/styles";
import { lighten } from "@material-ui/core/styles/colorManipulator";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Toolbar from "@material-ui/core/Toolbar";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";
import Edit from "@material-ui/icons/Edit";
import SaveIcon from "@material-ui/icons/Save";
import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import {
  SelectValidator,
  TextValidator,
  ValidatorForm,
} from "react-material-ui-form-validator";
import { connect } from "react-redux";

import { globalHistory } from "./../../history";
import { mapActionsToProps } from "./../../redux/api-connect/agents";
import { mapActionsExtensionToProps } from "./../../redux/api-connect/extension";

function desc(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function stableSort(array, cmp) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

function getSorting(order, orderBy) {
  return order === "desc"
    ? (a, b) => desc(a, b, orderBy)
    : (a, b) => -desc(a, b, orderBy);
}

const rows = [
  { id: "name", numeric: false, disablePadding: false, label: "Tên agent" },
  { id: "extensionId", numeric: false, disablePadding: false, label: "Máy lẻ" },
  {
    id: "maxNoAnswer",
    numeric: false,
    disablePadding: false,
    label: "Thời gian chờ tối đa",
  },
  {
    id: "busyDelay",
    numeric: false,
    disablePadding: false,
    label: "Thời gian đổ chuông",
  },
  { id: "type", numeric: false, disablePadding: false, label: "Loại" },
  { id: "status", numeric: false, disablePadding: false, label: "Trạng thái" },
  { id: "action", numeric: false, disablePadding: false, label: "Hành động" },
];

class EnhancedTableHead extends React.Component {
  state = {
    isShow: true,
  };
  createSortHandler = (property) => (event) => {
    this.props.onRequestSort(event, property);
  };

  render() {
    const { order, orderBy } = this.props;

    return (
      <TableHead>
        <TableRow>
          {rows.map((row) => {
            return (
              <TableCell
                key={row.id}
                numeric={row.numeric}
                padding="dense"
                sortDirection={orderBy === row.id ? order : false}>
                <Tooltip
                  title="Sort"
                  placement={row.numeric ? "bottom-end" : "bottom-start"}
                  enterDelay={300}>
                  <TableSortLabel
                    active={orderBy === row.id}
                    direction={order}
                    onClick={this.createSortHandler(row.id)}>
                    {row.label}
                  </TableSortLabel>
                </Tooltip>
              </TableCell>
            );
          }, this)}
        </TableRow>
      </TableHead>
    );
  }
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const toolbarStyles = (theme) => ({
  root: {
    paddingRight: theme.spacing.unit,
  },
  highlight:
    theme.palette.type === "light"
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  spacer: {
    flex: "1 1 100%",
  },
  actions: {
    color: theme.palette.text.secondary,
    flexDirection: "row",
    display: "flex",
  },
  title: {
    flex: "0 0 auto",
  },
  form: {
    width: 80,
    marginTop: 15,
  },
});

let EnhancedTableToolbar = (props) => {
  const { numSelected, classes, addNew } = props;
  return (
    <Toolbar
      className={classNames(classes.root, {
        [classes.highlight]: numSelected > 0,
      })}>
      <div className={classes.title}>
        {numSelected > 0 ? (
          <Typography color="inherit" variant="subheading">
            {numSelected} selected
          </Typography>
        ) : (
          <Typography variant="title" id="tableTitle">
            Agent
          </Typography>
        )}
      </div>
      <div className={classes.spacer} />
      <div className={classes.actions}>
        {numSelected > 0 ? (
          <div className={classes.actions}>
            <Tooltip title="Save">
              <IconButton aria-label="Save">
                <SaveIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Delete">
              <IconButton aria-label="Delete">
                <DeleteIcon />
              </IconButton>
            </Tooltip>
          </div>
        ) : (
          // <Tooltip title="Filter list">
          //   <IconButton aria-label="Filter list" onClick={props.searchForm}>
          //     <FilterListIcon />
          //   </IconButton>
          // </Tooltip>
          // <div className={classes.form}>
          //     <TextField
          //         id="search_name"
          //         placeholder="Tìm kiếm thành phố"
          //         margin="normal"
          //         variant="outlined"
          //         fullWidth
          //         onChange={props.searchForm}
          //     />
          // </div>
          <div className={classes.form}>
            <Button
              variant="fab"
              mini
              color="primary"
              aria-label="Add"
              className={classes.button}
              onClick={addNew}>
              <AddIcon />
            </Button>
          </div>
        )}
      </div>
    </Toolbar>
  );
};

EnhancedTableToolbar.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  searchForm: PropTypes.func,
  addNew: PropTypes.func,
};

EnhancedTableToolbar = withStyles(toolbarStyles)(EnhancedTableToolbar);

const styles = (theme) => ({
  root: {
    width: "100%",
  },
  table: {
    minWidth: 1020,
    // marginLeft: 50,
    // margin: 0
  },
  tableWrapper: {
    overflowX: "auto",
  },
  button: {
    margin: theme.spacing.unit,
  },
  marginInput: {
    marginBottom: 20,
  },
  modal: {
    position: "absolute",
    width: "50%",
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing.unit * 4,
    top: "50%",
    left: "50%",
    transform: `translate(-50%, -50%)`,
  },
});

class DataTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      order: "asc",
      orderBy: "calories",
      selected: [],
      page: 0,
      rowsPerPage: 5,
      search: "",
      isShow: false,
      showModal: false,
      id: 0,
      legTimeout: "",
      status: "",
      extensionId: "",
      maxNoAnswer: "",
      busyDelay: "",
      name: "",
      type: "",
      item: "",
    };
  }

  componentDidMount() {
    this.history = globalHistory();
  }

  componentWillMount() {
    this.props.extension && this.props.getExtensionAction();
  }

  handleChange = (name) => (event) => {
    this.setState({ [name]: event.target.checked });
  };

  handleRequestSort = (event, property) => {
    const orderBy = property;
    let order = "desc";

    if (this.state.orderBy === property && this.state.order === "desc") {
      order = "asc";
    }

    this.setState({ order, orderBy });
  };

  handleSelectAllClick = (event) => {
    const { agents } = this.props;

    if (event.target.checked) {
      this.setState((state) => ({ selected: agents.map((n) => n.id) }));
      return;
    }
    this.setState({ selected: [] });
  };

  handleClick = (event, id) => {
    const { selected } = this.state;
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    this.setState({ selected: newSelected });
  };

  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: event.target.value });
  };

  isSelected = (id) => this.state.selected.indexOf(id) !== -1;

  itemDetail(item) {
    this.history.push(`/agents/${item.id}`);
  }

  handleChangeInput = (name) => {
    return (e) => {
      this.setState({
        item: {
          ...this.state.item,
          [name]: e.target.value,
        },
      });
    };
  };

  handleModal(item) {
    this.state.item = item;
    this.setState({ showModal: true });
  }

  handleDelete(item) {
    this.props.deleteAAgent(item.id);
  }

  handleCloseModal() {
    this.setState({ showModal: false });
  }

  handleSubmit() {
    const {
      legTimeout,
      status,
      extensionId,
      maxNoAnswer,
      busyDelay,
      name,
      type,
    } = this.state.item;
    const id = this.state.item.id;
    const { updateAAgent } = this.props;
    updateAAgent &&
      updateAAgent(
        legTimeout,
        status,
        extensionId,
        maxNoAnswer,
        busyDelay,
        name,
        type,
        id
      );
    setTimeout(
      function () {
        this.setState({ showModal: false });
      }.bind(this),
      500
    );
  }

  handleAddNew() {
    this.history.push("/agents/create");
  }

  render() {
    const {
      classes,
      agents,
      extension: { items },
    } = this.props;
    const result =
      typeof items === "object"
        ? Object.keys(items).map((key) => items[key])
        : items;
    const {
      order,
      orderBy,
      selected,
      rowsPerPage,
      page,
      legTimeout,
      status,
      extensionId,
      maxNoAnswer,
      busyDelay,
      name,
      type,
      item,
    } = this.state;
    const emptyRows =
      rowsPerPage - Math.min(rowsPerPage, agents.length - page * rowsPerPage);
    return (
      <Paper className={classes.root}>
        <EnhancedTableToolbar addNew={this.handleAddNew.bind(this)} />
        <div className={classes.tableWrapper}>
          <Table className={classes.table} aria-labelledby="tableTitle">
            <EnhancedTableHead
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              // onSelectAllClick={this.handleSelectAllClick}
              onRequestSort={this.handleRequestSort}
              rowCount={agents.length}
            />
            <TableBody>
              {stableSort(agents, getSorting(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((n) => {
                  const isSelected = this.isSelected(n.id);
                  const checkState =
                    n.state === "Available" ? "Hoạt động" : "Tạm dừng";
                  return (
                    <TableRow hover key={n.id} selected={isSelected}>
                      <TableCell component="th" scope="row" padding="dense">
                        {n.name}
                      </TableCell>
                      <TableCell component="th" scope="row" padding="dense">
                        {result
                          ? result.map((item) => {
                              return n.extensionId == item.id
                                ? item.userId
                                : null;
                            })
                          : null}
                      </TableCell>
                      <TableCell component="th" scope="row" padding="dense">
                        {n.maxNoAnswer}
                      </TableCell>
                      <TableCell component="th" scope="row" padding="dense">
                        {n.busyDelay}
                      </TableCell>
                      <TableCell component="th" scope="row" padding="dense">
                        {n.type}
                      </TableCell>
                      <TableCell component="th" scope="row" padding="dense">
                        {n.status}
                      </TableCell>
                      <TableCell component="th" scope="row" padding="dense">
                        <IconButton
                          aria-label="Edit"
                          onClick={this.handleModal.bind(this, n)}>
                          <Edit />
                        </IconButton>
                        <IconButton
                          aria-label="Delete"
                          onClick={this.handleDelete.bind(this, n)}>
                          <DeleteIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  );
                })}
              {emptyRows > 0 && null}
            </TableBody>
          </Table>
          <Modal
            open={this.state.showModal}
            onClose={this.handleCloseModal.bind(this)}>
            <div className={classes.modal}>
              <ValidatorForm
                ref="form"
                onSubmit={this.handleSubmit.bind(this)}
                onError={(errors) => console.log(errors)}>
                <Card className={classes.card}>
                  <CardContent>
                    {/* <FormLabel className={classes.formLabel}>Edit Groups</FormLabel> */}
                    <FormGroup>
                      <Grid container spacing={24}>
                        <Grid item md={6}>
                          <TextValidator
                            variant="outlined"
                            className={classes.marginInput}
                            label="Tên"
                            onChange={this.handleChangeInput("name")}
                            name="name"
                            value={item ? item.name : ""}
                            inputStyle={classes.hideAutoFillColorStyle}
                            fullWidth
                            validators={["required"]}
                            errorMessages={[`Không được để trống`]}
                          />
                          <TextValidator
                            variant="outlined"
                            className={classes.marginInput}
                            label="Loại"
                            onChange={this.handleChangeInput("type")}
                            name="type"
                            value={item ? item.type : ""}
                            inputStyle={classes.hideAutoFillColorStyle}
                            fullWidth
                            validators={["required"]}
                            errorMessages={[`Không được để trống`]}
                          />
                          <SelectValidator
                            variant="outlined"
                            label="Máy lẻ"
                            onChange={this.handleChangeInput("extensionId")}
                            name="extensionId"
                            select
                            value={item ? item.extensionId : ""}
                            inputStyle={classes.hideAutoFillColorStyle}
                            fullWidth
                            validators={["required"]}
                            errorMessages={[`Không được để trống`]}
                            SelectProps={{
                              MenuProps: {
                                className: classes.menu,
                              },
                            }}>
                            {result
                              ? result.map((item) => {
                                  return (
                                    <MenuItem key={item.id} value={item.id}>
                                      {item.userId}
                                    </MenuItem>
                                  );
                                })
                              : null}
                          </SelectValidator>
                        </Grid>
                        <Grid item md={6}>
                          <TextValidator
                            variant="outlined"
                            className={classes.marginInput}
                            label="Thời gian chờ"
                            onChange={this.handleChangeInput("busyDelay")}
                            name="busyDelay"
                            value={item ? item.busyDelay : ""}
                            inputStyle={classes.hideAutoFillColorStyle}
                            fullWidth
                            validators={["required", "matchRegexp:^[0-9]+$"]}
                            errorMessages={[
                              `Không được để trống`,
                              "Thời gian chờ là số",
                            ]}
                          />
                          <TextValidator
                            variant="outlined"
                            className={classes.marginInput}
                            label="Thời gian chờ tối đa"
                            onChange={this.handleChangeInput("maxNoAnswer")}
                            name="maxNoAnswer"
                            value={item ? item.maxNoAnswer : ""}
                            inputStyle={classes.hideAutoFillColorStyle}
                            fullWidth
                            validators={["required", "matchRegexp:^[0-9]+$"]}
                            errorMessages={[
                              `Không được để trống`,
                              "Thời gian chờ tối đa là số",
                            ]}
                          />
                          <TextValidator
                            variant="outlined"
                            className={classes.marginInput}
                            placeholder="Thời gian kết thúc chờ"
                            onChange={this.handleChangeInput("legTimeout")}
                            name="legTimeout"
                            value={item ? item.legTimeout : ""}
                            inputStyle={classes.hideAutoFillColorStyle}
                            fullWidth
                            validators={["required", "matchRegexp:^[0-9]+$"]}
                            errorMessages={[
                              `Không được để trống`,
                              "Thời gian kết thúc chờ là số",
                            ]}
                          />
                        </Grid>
                      </Grid>
                      <SelectValidator
                        variant="outlined"
                        label="Trạng thái"
                        onChange={this.handleChangeInput("status")}
                        name="status"
                        select
                        value={item ? item.status : ""}
                        inputStyle={classes.hideAutoFillColorStyle}
                        fullWidth
                        validators={["required"]}
                        errorMessages={[`Không được để trống`]}
                        SelectProps={{
                          MenuProps: {
                            className: classes.menu,
                          },
                        }}>
                        <MenuItem key="Logged Out" value="Logged Out">
                          Logged Out
                        </MenuItem>
                        <MenuItem key="Available" value="Available">
                          Available
                        </MenuItem>
                        <MenuItem
                          key="Available (On Demand)"
                          value="Available (On Demand)">
                          Available (On Demand)
                        </MenuItem>
                        <MenuItem key="On Break" value="On Break">
                          On Break
                        </MenuItem>
                      </SelectValidator>
                    </FormGroup>
                  </CardContent>
                  <DialogActions>
                    <Button
                      type="submit"
                      color="primary"
                      variant="contained"
                      size="small">
                      Lưu
                    </Button>
                    <Button
                      onClick={this.handleCloseModal.bind(this)}
                      color="secondary"
                      variant="contained"
                      size="small">
                      Hủy
                    </Button>
                  </DialogActions>
                </Card>
              </ValidatorForm>
            </div>
          </Modal>
        </div>
        <TablePagination
          component="div"
          count={agents.length}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={[5, 10, 25, 50]}
          page={page}
          backIconButtonProps={{
            "aria-label": "Previous Page",
          }}
          nextIconButtonProps={{
            "aria-label": "Next Page",
          }}
          onChangePage={this.handleChangePage}
          onChangeRowsPerPage={this.handleChangeRowsPerPage}
        />
      </Paper>
    );
  }
}

DataTable.propTypes = {
  classes: PropTypes.object.isRequired,
  agents: PropTypes.array,
};

DataTable.defaultProps = {
  agents: [],
};

const mapStateToProps = (state) => ({
  extension: state.apiConnectExtension.extensions,
});

const ExtensionConnect = connect(
  mapStateToProps,
  mapActionsExtensionToProps
)(DataTable);

const Agent = connect(null, mapActionsToProps)(ExtensionConnect);

export default withStyles(styles)(Agent);
